import { configureStore } from "@reduxjs/toolkit";
import AllReducers from "./AllReducers";
import { authApi } from "./auth/authApi";
import { homeApi } from "./home/homeApi";
import { commonApi } from "./common/commonApi";
import { myAccountApi } from "./myaccount/myAccountApi";
import { productApi } from "./product/productApi";
import { CartApi } from "./cart/CartApi";
import { orderApi } from "./order/orderApi";

const store = configureStore({
  reducer: AllReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      homeApi.middleware,
      commonApi.middleware,
      myAccountApi.middleware,
      productApi.middleware,
      CartApi.middleware,
      orderApi.middleware,
    ),
});

export default store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
